module.exports = __webpack_public_path__ + "static/media/communityImage2.4a413134.png";